/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import {
  TransportOfferResponse,
  TransportOfferStatus,
  VehicleType,
} from 'src/graphql/generated/graphql.generated';
import {
  CoordinatesRecord,
  CoordinatesProps,
} from 'src/store/generated/coordinates-record.generated';
import {
  UnitPositionSnapshotRecord,
  UnitPositionSnapshotProps,
} from 'src/store/generated/unit-position-snapshot-record.generated';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface TransportOfferProps {
  id: string;
  status: TransportOfferStatus;
  rank: number;
  distanceInMiles: number | null;
  bearingInDegrees: number | null;
  estimatedDepartureTimeInMinutes: number | null;
  estimatedTimeEnRouteInMinutes: number | null;
  offerTime: Date | null;
  crewNotified: Date | null;
  transportCheckInitiated: Date | null;
  notificationAcknowledged: Date | null;
  responseReceived: Date | null;
  response: TransportOfferResponse;
  declineReasonId: string | null;
  declineSecondaryReasonId: string | null;
  nonReferralReasonId: string | null;
  nonReferralReasonNotes: string | null;
  cancellationReasonId: string | null;
  cancellationSecondaryReasonId: string | null;
  cancellationReasonNotes: string | null;
  outOfServiceEventId: string | null;
  unitId: string | null;
  vehicleId: string | null;
  agencyLocationId: string | null;
  unitDescription: string | null;
  isReferral: boolean | null;
  vehicleType: VehicleType | null;
  patientOriginatesAtUnit: boolean | null;
  vehicleCoordinates: CoordinatesProps | null;
  homeBaseDistanceInMiles: number | null;
  baseId: string | null;
  preferredRank: number | null;
  notes: string | null;
  wasBulkSkip: boolean;
  onBaseETAInMinutes: number | null;
  isOnDelay: boolean;
  isOneCallAgreement: boolean;
  specialtyTeamETLOInMinutes: number | null;
  specialtyTeamETEInMinutes: number | null;
  isInternalAgency: boolean;
  dateDeclinedOrAborted: Date | null;
  declinedOrAbortedById: string | null;
  crew: List<UnitPositionSnapshotProps> | null;
  etc: number | null;
  crewMustFlyToArriveAtSending: boolean | null;
  requestId: string;
  companyId: string;
  dateLastUpdated: Date;
  dateCreated: Date;
  dateDeleted: Date | null;
  lastUpdatedById: string | null;
}

export class TransportOfferRecord extends Record<TransportOfferProps>({
  id: null as any,
  status: null as any,
  rank: null as any,
  distanceInMiles: null as any,
  bearingInDegrees: null as any,
  estimatedDepartureTimeInMinutes: null as any,
  estimatedTimeEnRouteInMinutes: null as any,
  offerTime: null as any,
  crewNotified: null as any,
  transportCheckInitiated: null as any,
  notificationAcknowledged: null as any,
  responseReceived: null as any,
  response: null as any,
  declineReasonId: null as any,
  declineSecondaryReasonId: null as any,
  nonReferralReasonId: null as any,
  nonReferralReasonNotes: null as any,
  cancellationReasonId: null as any,
  cancellationSecondaryReasonId: null as any,
  cancellationReasonNotes: null as any,
  outOfServiceEventId: null as any,
  unitId: null as any,
  vehicleId: null as any,
  agencyLocationId: null as any,
  unitDescription: null as any,
  isReferral: null as any,
  vehicleType: null as any,
  patientOriginatesAtUnit: null as any,
  vehicleCoordinates: null as any,
  homeBaseDistanceInMiles: null as any,
  baseId: null as any,
  preferredRank: null as any,
  notes: null as any,
  wasBulkSkip: null as any,
  onBaseETAInMinutes: null as any,
  isOnDelay: null as any,
  isOneCallAgreement: null as any,
  specialtyTeamETLOInMinutes: null as any,
  specialtyTeamETEInMinutes: null as any,
  isInternalAgency: null as any,
  dateDeclinedOrAborted: null as any,
  declinedOrAbortedById: null as any,
  crew: null as any,
  etc: null as any,
  crewMustFlyToArriveAtSending: null as any,
  requestId: null as any,
  companyId: null as any,
  dateLastUpdated: null as any,
  dateCreated: null as any,
  dateDeleted: null as any,
  lastUpdatedById: null as any,
}) {
  public static fromJS(json: {
    id: string;
    status: TransportOfferStatus;
    rank: number;
    distanceInMiles: number | null;
    bearingInDegrees: number | null;
    estimatedDepartureTimeInMinutes: number | null;
    estimatedTimeEnRouteInMinutes: number | null;
    offerTime: string | number | Date | null;
    crewNotified: string | number | Date | null;
    transportCheckInitiated: string | number | Date | null;
    notificationAcknowledged: string | number | Date | null;
    responseReceived: string | number | Date | null;
    response: TransportOfferResponse;
    declineReasonId: string | null;
    declineSecondaryReasonId: string | null;
    nonReferralReasonId: string | null;
    nonReferralReasonNotes: string | null;
    cancellationReasonId: string | null;
    cancellationSecondaryReasonId: string | null;
    cancellationReasonNotes: string | null;
    outOfServiceEventId: string | null;
    unitId: string | null;
    vehicleId: string | null;
    agencyLocationId: string | null;
    unitDescription: string | null;
    isReferral: boolean | null;
    vehicleType: VehicleType | null;
    patientOriginatesAtUnit: boolean | null;
    vehicleCoordinates: any;
    homeBaseDistanceInMiles: number | null;
    baseId: string | null;
    preferredRank: number | null;
    notes: string | null;
    wasBulkSkip: boolean;
    onBaseETAInMinutes: number | null;
    isOnDelay: boolean;
    isOneCallAgreement: boolean;
    specialtyTeamETLOInMinutes: number | null;
    specialtyTeamETEInMinutes: number | null;
    isInternalAgency: boolean;
    dateDeclinedOrAborted: string | number | Date | null;
    declinedOrAbortedById: string | null;
    crew: any;
    etc: number | null;
    crewMustFlyToArriveAtSending: boolean | null;
    requestId: string;
    companyId: string;
    dateLastUpdated: string | number | Date;
    dateCreated: string | number | Date;
    dateDeleted: string | number | Date | null;
    lastUpdatedById: string | null;
  }): TransportOfferRecord {
    if (json == null) {
      throw new Error('TransportOfferRecord.fromJS: parameter cannot be null');
    }
    return new TransportOfferRecord({
      id: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
        'TransportOfferJson.id',
      ),
      status: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'status', TransportOfferStatus.Candidate),
        'TransportOfferJson.status',
      ),
      rank: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'rank', 0),
        'TransportOfferJson.rank',
      ),
      distanceInMiles: json.distanceInMiles,
      bearingInDegrees: json.bearingInDegrees,
      estimatedDepartureTimeInMinutes: json.estimatedDepartureTimeInMinutes,
      estimatedTimeEnRouteInMinutes: json.estimatedTimeEnRouteInMinutes,
      offerTime: json.offerTime != null ? new Date(json.offerTime) : null,
      crewNotified: json.crewNotified != null ? new Date(json.crewNotified) : null,
      transportCheckInitiated:
        json.transportCheckInitiated != null ? new Date(json.transportCheckInitiated) : null,
      notificationAcknowledged:
        json.notificationAcknowledged != null ? new Date(json.notificationAcknowledged) : null,
      responseReceived: json.responseReceived != null ? new Date(json.responseReceived) : null,
      response: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'response', TransportOfferResponse.Pending),
        'TransportOfferJson.response',
      ),
      declineReasonId: json.declineReasonId,
      declineSecondaryReasonId: json.declineSecondaryReasonId,
      nonReferralReasonId: json.nonReferralReasonId,
      nonReferralReasonNotes: json.nonReferralReasonNotes,
      cancellationReasonId: json.cancellationReasonId,
      cancellationSecondaryReasonId: json.cancellationSecondaryReasonId,
      cancellationReasonNotes: json.cancellationReasonNotes,
      outOfServiceEventId: json.outOfServiceEventId,
      unitId: json.unitId,
      vehicleId: json.vehicleId,
      agencyLocationId: json.agencyLocationId,
      unitDescription: json.unitDescription,
      isReferral: json.isReferral,
      vehicleType: json.vehicleType,
      patientOriginatesAtUnit: json.patientOriginatesAtUnit,
      vehicleCoordinates:
        json.vehicleCoordinates != null ? new CoordinatesRecord(json.vehicleCoordinates) : null,
      homeBaseDistanceInMiles: json.homeBaseDistanceInMiles,
      baseId: json.baseId,
      preferredRank: json.preferredRank,
      notes: json.notes,
      wasBulkSkip: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'wasBulkSkip', false),
        'TransportOfferJson.wasBulkSkip',
      ),
      onBaseETAInMinutes: json.onBaseETAInMinutes,
      isOnDelay: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'isOnDelay', false),
        'TransportOfferJson.isOnDelay',
      ),
      isOneCallAgreement: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'isOneCallAgreement', false),
        'TransportOfferJson.isOneCallAgreement',
      ),
      specialtyTeamETLOInMinutes: json.specialtyTeamETLOInMinutes,
      specialtyTeamETEInMinutes: json.specialtyTeamETEInMinutes,
      isInternalAgency: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'isInternalAgency', false),
        'TransportOfferJson.isInternalAgency',
      ),
      dateDeclinedOrAborted:
        json.dateDeclinedOrAborted != null ? new Date(json.dateDeclinedOrAborted) : null,
      declinedOrAbortedById: json.declinedOrAbortedById,
      crew:
        json.crew != null
          ? List<UnitPositionSnapshotRecord>(
              json.crew.map((o: any) => new UnitPositionSnapshotRecord(o)),
            )
          : null,
      etc: json.etc,
      crewMustFlyToArriveAtSending: json.crewMustFlyToArriveAtSending,
      requestId: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'requestId', '00000000-0000-0000-0000-000000000000'),
        'TransportOfferJson.requestId',
      ),
      companyId: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'companyId', '00000000-0000-0000-0000-000000000000'),
        'TransportOfferJson.companyId',
      ),
      dateLastUpdated: new Date(json.dateLastUpdated),
      dateCreated: new Date(json.dateCreated),
      dateDeleted: json.dateDeleted != null ? new Date(json.dateDeleted) : null,
      lastUpdatedById: json.lastUpdatedById,
    });
  }

  public static fromJSUnsafe(json: {
    id: string;
    status: TransportOfferStatus;
    rank: number;
    distanceInMiles: number | null;
    bearingInDegrees: number | null;
    estimatedDepartureTimeInMinutes: number | null;
    estimatedTimeEnRouteInMinutes: number | null;
    offerTime: string | number | Date | null;
    crewNotified: string | number | Date | null;
    transportCheckInitiated: string | number | Date | null;
    notificationAcknowledged: string | number | Date | null;
    responseReceived: string | number | Date | null;
    response: TransportOfferResponse;
    declineReasonId: string | null;
    declineSecondaryReasonId: string | null;
    nonReferralReasonId: string | null;
    nonReferralReasonNotes: string | null;
    cancellationReasonId: string | null;
    cancellationSecondaryReasonId: string | null;
    cancellationReasonNotes: string | null;
    outOfServiceEventId: string | null;
    unitId: string | null;
    vehicleId: string | null;
    agencyLocationId: string | null;
    unitDescription: string | null;
    isReferral: boolean | null;
    vehicleType: VehicleType | null;
    patientOriginatesAtUnit: boolean | null;
    vehicleCoordinates: any;
    homeBaseDistanceInMiles: number | null;
    baseId: string | null;
    preferredRank: number | null;
    notes: string | null;
    wasBulkSkip: boolean;
    onBaseETAInMinutes: number | null;
    isOnDelay: boolean;
    isOneCallAgreement: boolean;
    specialtyTeamETLOInMinutes: number | null;
    specialtyTeamETEInMinutes: number | null;
    isInternalAgency: boolean;
    dateDeclinedOrAborted: string | number | Date | null;
    declinedOrAbortedById: string | null;
    crew: any;
    etc: number | null;
    crewMustFlyToArriveAtSending: boolean | null;
    requestId: string;
    companyId: string;
    dateLastUpdated: string | number | Date;
    dateCreated: string | number | Date;
    dateDeleted: string | number | Date | null;
    lastUpdatedById: string | null;
  }): [TransportOfferRecord, Error[]] {
    if (json == null) {
      throw new Error('TransportOfferRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new TransportOfferRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
            'TransportOfferJson.id',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      status: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'status', TransportOfferStatus.Candidate),
            'TransportOfferJson.status',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      rank: tryOrDefault(
        () =>
          getFromOrThrow(json, (j) => propValueOrDefault(j, 'rank', 0), 'TransportOfferJson.rank'),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      distanceInMiles: tryOrDefault(
        () => json.distanceInMiles,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      bearingInDegrees: tryOrDefault(
        () => json.bearingInDegrees,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      estimatedDepartureTimeInMinutes: tryOrDefault(
        () => json.estimatedDepartureTimeInMinutes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      estimatedTimeEnRouteInMinutes: tryOrDefault(
        () => json.estimatedTimeEnRouteInMinutes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      offerTime: tryOrDefault(
        () => (json.offerTime != null ? new Date(json.offerTime) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      crewNotified: tryOrDefault(
        () => (json.crewNotified != null ? new Date(json.crewNotified) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transportCheckInitiated: tryOrDefault(
        () =>
          json.transportCheckInitiated != null ? new Date(json.transportCheckInitiated) : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      notificationAcknowledged: tryOrDefault(
        () =>
          json.notificationAcknowledged != null ? new Date(json.notificationAcknowledged) : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      responseReceived: tryOrDefault(
        () => (json.responseReceived != null ? new Date(json.responseReceived) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      response: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'response', TransportOfferResponse.Pending),
            'TransportOfferJson.response',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      declineReasonId: tryOrDefault(
        () => json.declineReasonId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      declineSecondaryReasonId: tryOrDefault(
        () => json.declineSecondaryReasonId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      nonReferralReasonId: tryOrDefault(
        () => json.nonReferralReasonId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      nonReferralReasonNotes: tryOrDefault(
        () => json.nonReferralReasonNotes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      cancellationReasonId: tryOrDefault(
        () => json.cancellationReasonId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      cancellationSecondaryReasonId: tryOrDefault(
        () => json.cancellationSecondaryReasonId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      cancellationReasonNotes: tryOrDefault(
        () => json.cancellationReasonNotes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      outOfServiceEventId: tryOrDefault(
        () => json.outOfServiceEventId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      unitId: tryOrDefault(
        () => json.unitId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      vehicleId: tryOrDefault(
        () => json.vehicleId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      agencyLocationId: tryOrDefault(
        () => json.agencyLocationId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      unitDescription: tryOrDefault(
        () => json.unitDescription,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isReferral: tryOrDefault(
        () => json.isReferral,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      vehicleType: tryOrDefault(
        () => json.vehicleType,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      patientOriginatesAtUnit: tryOrDefault(
        () => json.patientOriginatesAtUnit,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      vehicleCoordinates: tryOrDefault(
        () =>
          json.vehicleCoordinates != null ? new CoordinatesRecord(json.vehicleCoordinates) : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      homeBaseDistanceInMiles: tryOrDefault(
        () => json.homeBaseDistanceInMiles,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      baseId: tryOrDefault(
        () => json.baseId,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      preferredRank: tryOrDefault(
        () => json.preferredRank,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      notes: tryOrDefault(
        () => json.notes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      wasBulkSkip: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'wasBulkSkip', false),
            'TransportOfferJson.wasBulkSkip',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      onBaseETAInMinutes: tryOrDefault(
        () => json.onBaseETAInMinutes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isOnDelay: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'isOnDelay', false),
            'TransportOfferJson.isOnDelay',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isOneCallAgreement: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'isOneCallAgreement', false),
            'TransportOfferJson.isOneCallAgreement',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      specialtyTeamETLOInMinutes: tryOrDefault(
        () => json.specialtyTeamETLOInMinutes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      specialtyTeamETEInMinutes: tryOrDefault(
        () => json.specialtyTeamETEInMinutes,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      isInternalAgency: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'isInternalAgency', false),
            'TransportOfferJson.isInternalAgency',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dateDeclinedOrAborted: tryOrDefault(
        () => (json.dateDeclinedOrAborted != null ? new Date(json.dateDeclinedOrAborted) : null),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      declinedOrAbortedById: tryOrDefault(
        () => json.declinedOrAbortedById,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      crew: tryOrDefault(
        () =>
          json.crew != null
            ? List<UnitPositionSnapshotRecord>(
                json.crew.map((o: any) => new UnitPositionSnapshotRecord(o)),
              )
            : null,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      etc: tryOrDefault(
        () => json.etc,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      crewMustFlyToArriveAtSending: tryOrDefault(
        () => json.crewMustFlyToArriveAtSending,
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      requestId: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'requestId', '00000000-0000-0000-0000-000000000000'),
            'TransportOfferJson.requestId',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      companyId: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'companyId', '00000000-0000-0000-0000-000000000000'),
            'TransportOfferJson.companyId',
          ),
        (err) => errors.push(err),
      )!,
      dateLastUpdated: new Date(json.dateLastUpdated),
      dateCreated: new Date(json.dateCreated),
      dateDeleted: json.dateDeleted != null ? new Date(json.dateDeleted) : null,
      lastUpdatedById: json.lastUpdatedById,
    });

    return [record, errors];
  }

  constructor(props: TransportOfferProps) {
    super(props);
    if (props == null) {
      throw new Error('TransportOfferRecord constructor parameter cannot be null');
    }
  }
}

export abstract class TransportOfferViewModelBase implements TransportOfferProps {
  protected readonly _props: TransportOfferProps;
  private _json?: TransportOfferProps;

  get id(): string {
    return this._props.id;
  }
  get status(): TransportOfferStatus {
    return this._props.status;
  }
  get rank(): number {
    return this._props.rank;
  }
  get distanceInMiles(): number | null {
    return this._props.distanceInMiles;
  }
  get bearingInDegrees(): number | null {
    return this._props.bearingInDegrees;
  }
  get estimatedDepartureTimeInMinutes(): number | null {
    return this._props.estimatedDepartureTimeInMinutes;
  }
  get estimatedTimeEnRouteInMinutes(): number | null {
    return this._props.estimatedTimeEnRouteInMinutes;
  }
  get offerTime(): Date | null {
    return this._props.offerTime;
  }
  get crewNotified(): Date | null {
    return this._props.crewNotified;
  }
  get transportCheckInitiated(): Date | null {
    return this._props.transportCheckInitiated;
  }
  get notificationAcknowledged(): Date | null {
    return this._props.notificationAcknowledged;
  }
  get responseReceived(): Date | null {
    return this._props.responseReceived;
  }
  get response(): TransportOfferResponse {
    return this._props.response;
  }
  get declineReasonId(): string | null {
    return this._props.declineReasonId;
  }
  get declineSecondaryReasonId(): string | null {
    return this._props.declineSecondaryReasonId;
  }
  get nonReferralReasonId(): string | null {
    return this._props.nonReferralReasonId;
  }
  get nonReferralReasonNotes(): string | null {
    return this._props.nonReferralReasonNotes;
  }
  get cancellationReasonId(): string | null {
    return this._props.cancellationReasonId;
  }
  get cancellationSecondaryReasonId(): string | null {
    return this._props.cancellationSecondaryReasonId;
  }
  get cancellationReasonNotes(): string | null {
    return this._props.cancellationReasonNotes;
  }
  get outOfServiceEventId(): string | null {
    return this._props.outOfServiceEventId;
  }
  get unitId(): string | null {
    return this._props.unitId;
  }
  get vehicleId(): string | null {
    return this._props.vehicleId;
  }
  get agencyLocationId(): string | null {
    return this._props.agencyLocationId;
  }
  get unitDescription(): string | null {
    return this._props.unitDescription;
  }
  get isReferral(): boolean | null {
    return this._props.isReferral;
  }
  get vehicleType(): VehicleType | null {
    return this._props.vehicleType;
  }
  get patientOriginatesAtUnit(): boolean | null {
    return this._props.patientOriginatesAtUnit;
  }
  get vehicleCoordinates(): CoordinatesProps | null {
    return this._props.vehicleCoordinates;
  }
  get homeBaseDistanceInMiles(): number | null {
    return this._props.homeBaseDistanceInMiles;
  }
  get baseId(): string | null {
    return this._props.baseId;
  }
  get preferredRank(): number | null {
    return this._props.preferredRank;
  }
  get notes(): string | null {
    return this._props.notes;
  }
  get wasBulkSkip(): boolean {
    return this._props.wasBulkSkip;
  }
  get onBaseETAInMinutes(): number | null {
    return this._props.onBaseETAInMinutes;
  }
  get isOnDelay(): boolean {
    return this._props.isOnDelay;
  }
  get isOneCallAgreement(): boolean {
    return this._props.isOneCallAgreement;
  }
  get specialtyTeamETLOInMinutes(): number | null {
    return this._props.specialtyTeamETLOInMinutes;
  }
  get specialtyTeamETEInMinutes(): number | null {
    return this._props.specialtyTeamETEInMinutes;
  }
  get isInternalAgency(): boolean {
    return this._props.isInternalAgency;
  }
  get dateDeclinedOrAborted(): Date | null {
    return this._props.dateDeclinedOrAborted;
  }
  get declinedOrAbortedById(): string | null {
    return this._props.declinedOrAbortedById;
  }
  get crew(): List<UnitPositionSnapshotProps> | null {
    return this._props.crew;
  }
  get etc(): number | null {
    return this._props.etc;
  }
  get crewMustFlyToArriveAtSending(): boolean | null {
    return this._props.crewMustFlyToArriveAtSending;
  }
  get requestId(): string {
    return this._props.requestId;
  }
  get companyId(): string {
    return this._props.companyId;
  }

  get dateCreated(): Date {
    return this._props.dateCreated;
  }
  get dateLastUpdated(): Date {
    return this._props.dateLastUpdated;
  }
  get dateDeleted(): Date | null {
    return this._props.dateDeleted;
  }
  get lastUpdatedById(): string | null {
    return this._props.lastUpdatedById;
  }

  public get isCancelled() {
    return this._props.status === TransportOfferStatus.Cancelled;
  }
  public get isCandidate() {
    return this._props.status === TransportOfferStatus.Candidate;
  }
  public get isOffered() {
    return this._props.status === TransportOfferStatus.Offered;
  }
  public get isResponded() {
    return this._props.status === TransportOfferStatus.Responded;
  }
  public get isSkipped() {
    return this._props.status === TransportOfferStatus.Skipped;
  }
  public get isAborted() {
    return this._props.response === TransportOfferResponse.Aborted;
  }
  public get isAccepted() {
    return this._props.response === TransportOfferResponse.Accepted;
  }
  public get isDeclined() {
    return this._props.response === TransportOfferResponse.Declined;
  }
  public get isPending() {
    return this._props.response === TransportOfferResponse.Pending;
  }
  public get isAir() {
    return this._props.vehicleType === VehicleType.Air;
  }
  public get isFixedWing() {
    return this._props.vehicleType === VehicleType.FixedWing;
  }
  public get isGround() {
    return this._props.vehicleType === VehicleType.Ground;
  }
  public get isRotorWing() {
    return this._props.vehicleType === VehicleType.RotorWing;
  }
  public get isUnspecified() {
    return this._props.vehicleType === VehicleType.Unspecified;
  }

  public isAnyStatus(...transportOfferStatus: TransportOfferStatus[]) {
    return transportOfferStatus.includes(this._props.status);
  }
  public isAnyResponse(...transportOfferResponse: TransportOfferResponse[]) {
    return transportOfferResponse.includes(this._props.response);
  }
  public isAnyVehicleType(...vehicleType: VehicleType[]) {
    return this._props.vehicleType != null && vehicleType.includes(this._props.vehicleType);
  }

  constructor(props: TransportOfferProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        id: this._props.id,
        status: this._props.status,
        rank: this._props.rank,
        distanceInMiles: this._props.distanceInMiles,
        bearingInDegrees: this._props.bearingInDegrees,
        estimatedDepartureTimeInMinutes: this._props.estimatedDepartureTimeInMinutes,
        estimatedTimeEnRouteInMinutes: this._props.estimatedTimeEnRouteInMinutes,
        offerTime: this._props.offerTime,
        crewNotified: this._props.crewNotified,
        transportCheckInitiated: this._props.transportCheckInitiated,
        notificationAcknowledged: this._props.notificationAcknowledged,
        responseReceived: this._props.responseReceived,
        response: this._props.response,
        declineReasonId: this._props.declineReasonId,
        declineSecondaryReasonId: this._props.declineSecondaryReasonId,
        nonReferralReasonId: this._props.nonReferralReasonId,
        nonReferralReasonNotes: this._props.nonReferralReasonNotes,
        cancellationReasonId: this._props.cancellationReasonId,
        cancellationSecondaryReasonId: this._props.cancellationSecondaryReasonId,
        cancellationReasonNotes: this._props.cancellationReasonNotes,
        outOfServiceEventId: this._props.outOfServiceEventId,
        unitId: this._props.unitId,
        vehicleId: this._props.vehicleId,
        agencyLocationId: this._props.agencyLocationId,
        unitDescription: this._props.unitDescription,
        isReferral: this._props.isReferral,
        vehicleType: this._props.vehicleType,
        patientOriginatesAtUnit: this._props.patientOriginatesAtUnit,
        vehicleCoordinates: this._props.vehicleCoordinates,
        homeBaseDistanceInMiles: this._props.homeBaseDistanceInMiles,
        baseId: this._props.baseId,
        preferredRank: this._props.preferredRank,
        notes: this._props.notes,
        wasBulkSkip: this._props.wasBulkSkip,
        onBaseETAInMinutes: this._props.onBaseETAInMinutes,
        isOnDelay: this._props.isOnDelay,
        isOneCallAgreement: this._props.isOneCallAgreement,
        specialtyTeamETLOInMinutes: this._props.specialtyTeamETLOInMinutes,
        specialtyTeamETEInMinutes: this._props.specialtyTeamETEInMinutes,
        isInternalAgency: this._props.isInternalAgency,
        dateDeclinedOrAborted: this._props.dateDeclinedOrAborted,
        declinedOrAbortedById: this._props.declinedOrAbortedById,
        crew: this._props.crew,
        etc: this._props.etc,
        crewMustFlyToArriveAtSending: this._props.crewMustFlyToArriveAtSending,
        requestId: this._props.requestId,
        companyId: this._props.companyId,
        dateLastUpdated: this._props.dateLastUpdated,
        dateCreated: this._props.dateCreated,
        dateDeleted: this._props.dateDeleted,
        lastUpdatedById: this._props.lastUpdatedById,
      };
    }
    return this._json;
  }
}

//#region Selectors

export const selectAllTransportOfferEntities = (state: AppState) =>
  state.entityStores.transportOffer.entities;

export const selectTransportOfferById = (id: string) => (state: AppState) =>
  state.entityStores.transportOffer.entities.get(id);

export const selectTransportOfferMetadataById = (id: string) => (state: AppState) =>
  state.entityStores.transportOffer.meta.get(id);

export const selectTransportOfferAndMetadataById = (id: string) =>
  createSelector(
    selectTransportOfferById(id),
    selectTransportOfferMetadataById(id),
    (transportOffer, meta) => ({ transportOffer, meta }),
  );

export function selectTransportOfferEntitiesByIds(ids: string[]) {
  return createSelector(
    selectAllTransportOfferEntities,

    (entities) => {
      // TODO: Once we're on TS 3.5+, I don't think we'll need use type assertions
      const entries = ids.map((id) => [id, entities.get(id)]) as unknown as Iterable<
        [string, TransportOfferRecord | undefined]
      >;
      return Map(entries);
    },
  );
}

export function selectTransportOfferEntitiesByStatus(status: TransportOfferStatus) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.status === status).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByRank(rank: number) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.rank === rank).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByDistanceInMiles(distanceInMiles: number) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.distanceInMiles === distanceInMiles).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByBearingInDegrees(bearingInDegrees: number) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.bearingInDegrees === bearingInDegrees).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByEstimatedDepartureTimeInMinutes(
  estimatedDepartureTimeInMinutes: number,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities
      .filter((e) => e.estimatedDepartureTimeInMinutes === estimatedDepartureTimeInMinutes)
      .valueSeq(),
  );
}

export function selectTransportOfferEntitiesByEstimatedTimeEnRouteInMinutes(
  estimatedTimeEnRouteInMinutes: number,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities
      .filter((e) => e.estimatedTimeEnRouteInMinutes === estimatedTimeEnRouteInMinutes)
      .valueSeq(),
  );
}

export function selectTransportOfferEntitiesByOfferTime(offerTime: Date) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.offerTime === offerTime).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByCrewNotified(crewNotified: Date) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.crewNotified === crewNotified).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByTransportCheckInitiated(
  transportCheckInitiated: Date,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.transportCheckInitiated === transportCheckInitiated).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByNotificationAcknowledged(
  notificationAcknowledged: Date,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.notificationAcknowledged === notificationAcknowledged).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByResponseReceived(responseReceived: Date) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.responseReceived === responseReceived).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByResponse(response: TransportOfferResponse) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.response === response).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByDeclineReasonId(declineReasonId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.declineReasonId === declineReasonId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByDeclineSecondaryReasonId(
  declineSecondaryReasonId: string,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.declineSecondaryReasonId === declineSecondaryReasonId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByNonReferralReasonId(nonReferralReasonId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.nonReferralReasonId === nonReferralReasonId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByNonReferralReasonNotes(
  nonReferralReasonNotes: string,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.nonReferralReasonNotes === nonReferralReasonNotes).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByCancellationReasonId(cancellationReasonId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.cancellationReasonId === cancellationReasonId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByCancellationSecondaryReasonId(
  cancellationSecondaryReasonId: string,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities
      .filter((e) => e.cancellationSecondaryReasonId === cancellationSecondaryReasonId)
      .valueSeq(),
  );
}

export function selectTransportOfferEntitiesByCancellationReasonNotes(
  cancellationReasonNotes: string,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.cancellationReasonNotes === cancellationReasonNotes).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByOutOfServiceEventId(outOfServiceEventId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.outOfServiceEventId === outOfServiceEventId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByUnitId(unitId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.unitId === unitId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByVehicleId(vehicleId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.vehicleId === vehicleId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByAgencyLocationId(agencyLocationId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.agencyLocationId === agencyLocationId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByUnitDescription(unitDescription: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.unitDescription === unitDescription).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByIsReferral(isReferral: boolean) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.isReferral === isReferral).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByVehicleType(vehicleType: VehicleType) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.vehicleType === vehicleType).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByPatientOriginatesAtUnit(
  patientOriginatesAtUnit: boolean,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.patientOriginatesAtUnit === patientOriginatesAtUnit).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByHomeBaseDistanceInMiles(
  homeBaseDistanceInMiles: number,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.homeBaseDistanceInMiles === homeBaseDistanceInMiles).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByBaseId(baseId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.baseId === baseId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByPreferredRank(preferredRank: number) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.preferredRank === preferredRank).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByNotes(notes: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.notes === notes).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByWasBulkSkip(wasBulkSkip: boolean) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.wasBulkSkip === wasBulkSkip).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByOnBaseETAInMinutes(onBaseETAInMinutes: number) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.onBaseETAInMinutes === onBaseETAInMinutes).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByIsOnDelay(isOnDelay: boolean) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.isOnDelay === isOnDelay).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByIsOneCallAgreement(isOneCallAgreement: boolean) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.isOneCallAgreement === isOneCallAgreement).valueSeq(),
  );
}

export function selectTransportOfferEntitiesBySpecialtyTeamETLOInMinutes(
  specialtyTeamETLOInMinutes: number,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.specialtyTeamETLOInMinutes === specialtyTeamETLOInMinutes).valueSeq(),
  );
}

export function selectTransportOfferEntitiesBySpecialtyTeamETEInMinutes(
  specialtyTeamETEInMinutes: number,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.specialtyTeamETEInMinutes === specialtyTeamETEInMinutes).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByIsInternalAgency(isInternalAgency: boolean) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.isInternalAgency === isInternalAgency).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByDateDeclinedOrAborted(dateDeclinedOrAborted: Date) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.dateDeclinedOrAborted === dateDeclinedOrAborted).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByDeclinedOrAbortedById(declinedOrAbortedById: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.declinedOrAbortedById === declinedOrAbortedById).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByEtc(etc: number) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.etc === etc).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByCrewMustFlyToArriveAtSending(
  crewMustFlyToArriveAtSending: boolean,
) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities
      .filter((e) => e.crewMustFlyToArriveAtSending === crewMustFlyToArriveAtSending)
      .valueSeq(),
  );
}

export function selectTransportOfferEntitiesByRequestId(requestId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.requestId === requestId).valueSeq(),
  );
}

export function selectTransportOfferEntitiesByCompanyId(companyId: string) {
  return createSelector(selectAllTransportOfferEntities, (entities) =>
    entities.filter((e) => e.companyId === companyId).valueSeq(),
  );
}
//#endregion Selectors
